import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC4VQRWQPziwgXLFd6yC8VzkzS3b5kNz74",
  authDomain: "tuscanyhouse-2ccda.firebaseapp.com",
  projectId: "tuscanyhouse-2ccda",
  storageBucket: "tuscanyhouse-2ccda.firebasestorage.app",
  messagingSenderId: "20064243318",
  appId: "1:20064243318:web:22abed1fd2538724dfd957",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
